  import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
  
  /**
   * Builds a CSL date-parts control as a nested FormArray structure:
   * [ [ part1, part2?, part3? ] ]
   */
  export const buildDateParts = (parts: Array<string | number>, formBuilder: FormBuilder): FormArray => {
    const inner = formBuilder.array<FormControl>([]);
    parts.forEach((p) => inner.push(formBuilder.control(p)));
    const outer = formBuilder.array<FormArray>([inner]);
    return outer;
  }

  /**
   * Builds a complete FormGroup for CSL date-variable fields.
   * Creates the proper structure with date-parts as a FormArray that can contain up to 2 date ranges.
   * Each date range is itself a FormArray with up to 3 parts (year, month, day).
   */
  export const buildDateVariableFormGroup = (formBuilder: FormBuilder): FormGroup => {
    return formBuilder.group({
      "date-parts": formBuilder.array([
        formBuilder.array([
          formBuilder.control(""), // Year
          formBuilder.control(""), // Month
          formBuilder.control(""), // Day
        ]),
      ]),
      season: [""],
      circa: [""],
      literal: [""],
      raw: [""],
    });
  }
